import React, { ReactElement, useState } from "react";
import { THEMES, ThemeName, getTheme, setTheme } from "../theme";
import SelectMenu from "./SelectMenu";

/**
 * A drop-down for the personal theme (only this player's screen changes). It lists every theme in THEMES, so
 * adding a theme there is all that is needed here.
 */
export default function ThemeMenu(props: { variant: "chip" | "field" }): ReactElement {
  const [theme, setThemeState] = useState<ThemeName>(getTheme());
  return (
    <SelectMenu<ThemeName>
      variant={props.variant}
      title="Theme"
      options={THEMES.map((t) => ({ value: t.name, label: t.label, swatch: t.swatch }))}
      value={theme}
      onChange={(name) => {
        setTheme(name);
        setThemeState(name);
      }}
    />
  );
}
